import { jsx as _jsx } from "react/jsx-runtime";
import Select from '../../../../components/Select';
import t from '../../../../lib/translate';
var ChangeTypeSelector = function (_a) {
    var onChange = _a.onChange, changeTypes = _a.changeTypes;
    return _jsx(Select, { label: t('templates.edit.select.change.type'), onChange: function (event) {
            onChange(event);
        }, defaultValue: { value: changeTypes[0], label: changeTypes[0] }, options: changeTypes === null || changeTypes === void 0 ? void 0 : changeTypes.map(function (changeType) { return ({ value: changeType, label: changeType }); }) });
};
export default ChangeTypeSelector;
